<div *ngIf="showLoader">

    <div fxLayout="row" fxLayoutAlign="center center" *ngIf="isLoading | async" class="overlay">

        <div class="loader"></div>

    </div>

</div>
